import React, { useContext } from 'react';
import DropdownContext from './DropdownContext';
var noop = function noop() {};
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */

export function useDropdownToggle() {
  var _ref = useContext(DropdownContext) || {},
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$toggle = _ref.toggle,
    toggle = _ref$toggle === void 0 ? noop : _ref$toggle,
    setToggle = _ref.setToggle;
  return [{
    ref: setToggle || noop,
    'aria-haspopup': true,
    'aria-expanded': !!show
  }, {
    show: show,
    toggle: toggle
  }];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */
function DropdownToggle(_ref2) {
  var children = _ref2.children;
  var _useDropdownToggle = useDropdownToggle(),
    props = _useDropdownToggle[0],
    _useDropdownToggle$ = _useDropdownToggle[1],
    show = _useDropdownToggle$.show,
    toggle = _useDropdownToggle$.toggle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    show: show,
    toggle: toggle,
    props: props
  }));
}
DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
/** @component */

export default DropdownToggle;